/**
 * Created by karora on 12/03/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
/*
 * Format a Number of degrees to something with only 1 digit after the decimal
 */
@Pipe({name: 'degrees'})
export class DegreesPipe implements PipeTransform {
  transform(value: number): string {
    let newVal = Math.round(value * 10) / 10;
    let intPart = Math.trunc(newVal);
    let decPart = (newVal * 10) % 10;
    return '' + intPart + '.' + decPart;
  }
}
